// src/App.tsx
import  React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import StatsChart from '../components/StatsChart';
import NbBateauxChart from '../components/chart/NbBateauxChart';
import PlacesParPortStackedBar from '../components/chart/PlacesParPortStackedBar';
import DoughnutQuantitesFamille from '../components/chart/DoughnutQuantitesFamille';
import { useSettingsLocal } from '../hooks/useSettingsLocal';
import DoughnutCategorieBat from '../components/chart/DoughnutCategorieBat';
import DoughnutTypeBat from '../components/chart/DoughnutTypeBat';

export default function Stats() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [stats] = useState([
      { date: 'Lun', valeur: 10 },
      { date: 'Mar', valeur: 20 },
      { date: 'Mer', valeur: 15 },
      { date: 'Jeu', valeur: 30 },
      { date: 'Ven', valeur: 25 },
      { date: 'Sam', valeur: 35 },
      { date: 'Dim', valeur: 40 },
    ]);
  
      const currentYear = new Date().getFullYear();
    const [annee, setAnnee] = useState(currentYear);
    const [mois, setMois] = useState<number | undefined>(undefined);
  
    const handleAnneeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setAnnee(parseInt(e.target.value));
    };
  
    const handleMoisChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const val = e.target.value;
      setMois(val === '' ? undefined : parseInt(val));
    };

     const today = new Date().toISOString().split('T')[0];
     
    const { settings } = useSettingsLocal();
  
    return (
      <div className="min-h-screen flex bg-[#f9fafb]">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="flex flex-col flex-1 lg:ml-64">
          <Header onOpenSidebar={() => setIsSidebarOpen(true)} />
  
          <main className="flex-1 bg-gray-50 p-6 dark:bg-darkMode pt-16">

            <div className="flex flex-col sm:flex-row justify-between   gap-4 mb-6">

              <h1 className="text-2xl font-bold text-dark dark:text-white mb-6">Statistiques</h1>
                <div className="flex flex-col sm:flex-row gap-4 mb-6">
                    <div>
                    <label className="block text-sm font-medium text-gray-600 dark:text-white">Année</label>
                    <select
                        value={annee}
                        onChange={handleAnneeChange}
                         className="mt-1 block w-full rounded-md border-gray-300 shadow-sm px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500"
                    >
                        {[...Array(10)].map((_, i) => {
                        const year = currentYear - i;
                        return (
                            <option key={year} value={year}>
                            {year}
                            </option>
                        );
                        })}
                    </select>
                    </div>
    
                    <div>
                    <label className="block text-sm font-medium text-gray-600 dark:text-white">Mois (optionnel)</label>
                    <select
                        value={mois ?? ''}
                        onChange={handleMoisChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm px-3 py-2 text-sm focus:border-blue-500 focus:ring-blue-500"
                    >
                        <option value="">Tous</option>
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                        <option key={m} value={m}>
                            {new Date(0, m - 1).toLocaleString('fr-FR', { month: 'long' })}
                        </option>
                        ))}
                    </select>
                    </div>
                </div>
            </div>
            
            
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 ">
              
  
              
              
              
  
                  
               {/* <div className="col-span-1">
                
              </div> */}

              
               {/* 🟩 Camembert (ligne complète aussi) */}
              {settings.cards.nbBateauxChart &&  <div className="col-span-1 md:col-span-2 xl:col-span-2">
                  <NbBateauxChart annee={annee} mois={mois} />
              </div>}

              {settings.cards.doughnutFamilles && <div className="col-span-1 md:col-span-1 xl:col-span-1">
                  
                  <DoughnutQuantitesFamille annee={annee} mois={mois} />
              </div>}

              
              {settings.cards.portStackedBars && <div className="col-span-1 md:col-span-2 xl:col-span-2">
                  
                  <PlacesParPortStackedBar date={today} sortBy="libres" limit={12} height={420} />
              </div>}

              {settings.cards.doughnutCategorieBat && <div className="col-span-1 md:col-span-1 xl:col-span-1">
                <DoughnutCategorieBat
                  annee={annee}
                  mois={mois}
                  maxSlices={15}
                  title="Catégories de Bateaux"
                />  
              </div>}


              {settings.cards.doughnutTypeBat && <div className="col-span-1 md:col-span-1 xl:col-span-1">
                <DoughnutTypeBat
                  annee={annee}
                  mois={mois}
                  maxSlices={15}
                  title="Types de Bateaux"
                />
              </div>}
  
              
            </div>
          </main>
        </div>
      </div>
    );
  }
  